import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function TaekwondoNearMeWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-3443">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3444">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3445">
          <div data-id="element-3446">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-3447">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-3448">
              {['Olympic-style Taekwondo techniques', 'Practical self-defense fundamentals', 'Improved balance, coordination, and agility', 'Goal setting through the belt ranking system', 'Discipline and respect for oneself and others'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-3449">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-3450" />
                  <span data-id="element-3451">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-3452">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-3453">
                Find the Right Class or Program
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-3454">
            <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1200&q=80" alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-3455" />
          </div>
        </div>
      </div>
    </section>;
}